// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uKvx","title":"styles_title__vC61w"};